import { type CSSProperties } from 'styled-components';

export const getAlignment = (alignment: CSSProperties['textAlign']) => {
  if (alignment === 'left') {
    return 'flex-start';
  }

  if (alignment === 'right') {
    return 'flex-end';
  }

  return alignment;
};
